"use strict";

var _classCallCheck = require("/vercel/path0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/vercel/path0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/vercel/path0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletUIError = void 0;

var WalletUIError =
/*#__PURE__*/
function (_Error) {
  _inherits(WalletUIError, _Error);

  function WalletUIError(message, errorCode) {
    var _this;

    _classCallCheck(this, WalletUIError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WalletUIError).call(this, message));
    _this.message = message;
    _this.errorCode = errorCode;
    return _this;
  }

  return WalletUIError;
}(_wrapNativeSuper(Error));

exports.WalletUIError = WalletUIError;
WalletUIError.UserRejectedRequest = new WalletUIError("User rejected request");
WalletUIError.SwitchEthereumChainUnsupportedChainId = new WalletUIError("Unsupported chainId", 4902);